export const API_BASE =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:3000";
export const SocietySections = [1, 2, 3, 4];
export const GenderTypes = ["mr", "mrs", "mx", "no_selection"];
export const AllUserGroups = [
  "unassigned",
  "administrator",
  "member",
  "manager",
  "representative",
  "reviewer",
  "all",
];
export const SelectionUserGroups = [
  "administrator",
  "member",
  "manager",
  "representative",
  "reviewer",
];
export const UserMemberTypes = ["A", "As", "I", "Is", "F", "YM"];
export const SubmissionStates = ["approve", "decline", "undecided"];
export const PaymentStates = ["paid", "notPaid"];
